import React, { useState, useContext, useRef, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import {
  TextInput,
  DateInput,
  CustomSwitch,
  LocalizationAutocomplete,
  FloatInput,
  IntInput,
} from "components/Input/Index.js";
import CustomSelect from "components/Input/CustomSelect.js";
import Button from "@mui/material/Button";
import SmallButton from "components/CustomButtons/Button.js";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { mandates } from "variables/markets";
import { memberorderStatusDataAdmin } from "variables/lists/markets";
import { putMarketMembershipOrder, getMarketMembership, getAccountContracts, getAccountDsos } from "services/ConfigServices";
import { MarketsContext } from "context/MarketsContext";
import { memberorder } from "variables/markets";
import { meters } from "variables/markets";
import { metersStatusData } from "variables/lists/markets";
import { compte } from "variables/patrimoine.js";
import { statusData, divisionUnitData } from "variables/lists/patrimoine";
import { site, meter as metertext } from "variables/patrimoine.js";
import { datedistributionData } from "variables/lists/meters";
import ImageList from "@mui/material/ImageList";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import AddGroupDialog from "components/Patrimoine/Group/AddGroupDialog";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "@mui/icons-material/Add";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import uuid from "react-uuid";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

const ParametersTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
  margin-top: 12px;
`;
const ParametersNote = styled.div`
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
  margin-top: 12px;
`;
const TreeHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles2 = makeStyles(styles);

function AddMeterToAccountDialog(props) {
  const { closeModal, refetch, serviceorder, market } = props;
  const appContext = useContext(AdvancedSearchContext);
  const { setTreemustrefresh, setSelectedNodesInfo, setGroupchanged, chartIdGroup, groupAccountListById, groupTypeListById } = appContext;

  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [button2Disabled, setButton2Disabled] = useState(false);

  const energy = market.parameters.general.energy;

  const [page, setPage] = useState(1);

  const [membershipGroup, setMembershipGroup] = useState();
  const [accountid, setAccountid] = useState();
  console.log(serviceorder);

  //Market Meter
  const [marketstatus, setMarketStatus] = useState("in");
  const [datebegin, setDatebegin] = useState("");
  const [dateend, setDateend] = useState("");
  const [description, setDescription] = useState("");

  //Account meter
  const [utilitiesData, setUtilitiesData] = useState([]);
  const [dsoData, setDsoData] = useState([]);

  const [clef, setClef] = useState();
  const [meternumber, setMeternumber] = useState(serviceorder.parameters.pdl || "");
  const [serialnumber, setSerialnumber] = useState();
  const [name, setName] = useState();
  const [options, setOptions] = useState([]);
  const [validatedAddress, setValidatedAddress] = useState({});
  const [status, setStatus] = useState("");
  const [address, setAddress] = useState(serviceorder.parameters.pdladdress || "");
  const [inputValue, setInputValue] = useState("");
  const loaded = useRef(false);
  const [metersDso, setMetersDso] = useState("");
  const [monthlyconsumption, setMonthlyconsumption] = useState(false);
  const [dailyconsumption, setDailyconsumption] = useState(false);
  const [loadcurve, setloadcurve] = useState(false);
  const [contractualdata, setContractualdata] = useState(false);
  const [utilitydata, setUtilitydata] = useState(false);
  const [associatedcontractid, setAssociatedcontractid] = useState("");

  //Attribution
  const [divisionunit, setDivisionunit] = useState("");
  const [divisionvalue, setDivisionvalue] = useState("");
  const [datedistribution, setDatedistribution] = useState("");
  const [groups, setGroups] = useState("");
  const [groupsParent, setGroupsParent] = useState(
    market?.parameters?.general?.groups?.[0]
  );
  const [openAdd, setOpenAdd] = React.useState(null);

  console.log(groups);

  //Market Meter
  const handleMarketStatusChange = (event) => { setMarketStatus(event.target.value); };
  const handleDatebeginChange = (event) => { setDatebegin(event.target.value); };
  const handleDateendChange = (event) => { setDateend(event.target.value); };
  const handleDescriptionChange = (event) => { setDescription(event.target.value); };

  //Account meter
  const handleClefChange = (e) => {
    setClef(e.target.value);
  };
  const handleMeternumberChange = (e) => {
    setMeternumber(e.target.value);
  };
  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };
  const handleSerialnumberChange = (e) => {
    setSerialnumber(e.target.value);
  };
  const handleNameChange = (e) => {
    setName(e.target.value);
  };
  const handleDsoChange = (e) => {
    setMetersDso(e.target.value);
  };
  const handleMonthlyconsumptionChange = (e) => {
    setMonthlyconsumption(!monthlyconsumption);
  };
  const handleDailyconsumptionChange = (e) => {
    setDailyconsumption(!dailyconsumption);
  };
  const handleLoadcurveChange = (e) => {
    setloadcurve(!loadcurve);
  };
  const handleContractualdataChange = (e) => {
    setContractualdata(!contractualdata);
  };
  const handleUtilitydataChange = (e) => {
    setUtilitydata(!utilitydata);
  };
  const handleAssociatedcontractidChange = (e) => {
    setAssociatedcontractid(e.target.value);
  };

  //Attribution
  const handleDivisionunitChange = (event) => { setDivisionunit(event.target.value); };
  const handleDivisionvalueChange = (event) => { setDivisionvalue(event.target.value); };
  const handleDatedistributionChange = (event) => { setDatedistribution(event.target.value); };
  const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };
  const handleAddClose = () => {
    setOpenAdd(false);
  };
  const handleAddSuccess = (newidgroup, newgroupname) => {
    // setSelectedNodesInfo(newgroupname);
    setGroupchanged(chartIdGroup); //we want to stay on the same group
    setTreemustrefresh(true);
  };

  //Page
  const handleNextPage = (event) => {
    setPage(2);
  };
  useEffect(() => {
    let disabled = true;
    console.log(groups,divisionunit,divisionvalue, datedistribution);
    if(groups && divisionunit && divisionvalue && datedistribution)
    {
      
      if(groups !== '0')
      {
        let type = groupTypeListById[""+groups];
        console.log(type);
        if(type && type !== '0.0' && type !== '0.1' && type !== '0.2' && type !== '4.0')
        {
          if(divisionvalue > 0)
            disabled = false;
        }
      }
    }
    setButton2Disabled(disabled);
  }, [groups,divisionunit,divisionvalue,datedistribution]);

  useEffect(() => {
    let disabled = true;
    if(meternumber)
    {
      disabled = false;
    }
    setButtonDisabled(disabled);
  }, [meternumber]);

  const handleSubmit = (event) => {
    console.log("handle submit");
    validateServiceOrderexectutionFunction(event);
  };


  useEffect(() => {
    axios
      .get(
        getMarketMembership(serviceorder.parameters.marketmembershipid),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        if (res.data.membership) {
          setMembershipGroup(res.data.membership.parameters.groups[0]);
          setAccountid(groupAccountListById["" + res.data.membership.parameters.groups[0]]);
          setGroupsParent(res.data.membership.parameters.groups[0]);
        }
      });

  }, []);

  useEffect(() => {
    if (accountid) {
      axios
        .get(
          getAccountContracts(accountid, energy),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          let tmpUtilitiesData = res.data.contracts?.map((data) => {
            return (
              { name: data.details.contractnumber + " (" + data.details.name + ")", id: data.uuid }
            );
          });
          setUtilitiesData(tmpUtilitiesData);
        });
    }
  }, [accountid]);

  useEffect(() => {
    if (accountid) {
      axios
        .get(
          getAccountDsos(accountid, energy),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {


          let tmpDsoData = res.data.dsos?.map((data) => {
            return (
              { name: data.details.name, id: data.uuid }
            );
          });
          setDsoData(tmpDsoData);
        });
    }
  }, [accountid]);

  const validateServiceOrderexectutionFunction = async (event) => {
    console.log("validateServiceOrderexectutionFunction");
    let idSelected = serviceorder.id;
    let url = putMarketMembershipOrder(idSelected, market.id, 'accountmeter');
    await axios
      .put(url,
        {
          serviceorderparameters:
          {
            ...serviceorder.parameters,
            status: 'executed',
          },
          metermarketparameters: {
            marketmembershipid: serviceorder.parameters.marketmembershipid,
            status: marketstatus,
            datebegin,
            dateend,
            description,
            meternumber,
          },
          accountmeterparameters: {
            uuid: uuid(),
            energy,
            meternumber,
            details: {
              clef,
              serialnumber,
              name,
              address,
              status,
              monthlyconsumption,
              dailyconsumption,
              loadcurve,
              contractualdata,
              utilitydata,
              associatedcontractid,
              dso: metersDso,
            },
          },
          attributionparameters: {
            divisionunit,
            divisionvalue,
            datedistribution,
            meternumber,
            uuid: uuid(),
          },
          attributiongroup:  groups,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },

        })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `L'ordre de service a été validé`
          );
          closeModal();
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const classes = useStyles();
  const classes2 = useStyles2();
  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          {page === 1 ?
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <ParametersTitle>{memberorder.marketparameters}</ParametersTitle>
              <div>
                <TextInput
                  isRequired
                  inputTitle={memberorder.marketmembershipname}
                  textInput={serviceorder.parameters.marketmembershipname + " (" + serviceorder.parameters.marketmembershipnumber + ")"}
                  disabled
                />
              </div>
              <div>
                <CustomSelect
                  isRequired
                  inputTitle={meters.status}
                  selectValue={marketstatus}
                  handleSelectValueChange={handleMarketStatusChange}
                  data={metersStatusData}
                  disabled
                />
              </div>
              <div>
                <DateInput
                  inputTitle={meters.datebegin}
                  dateInput={datebegin}
                  handleDateInputChange={handleDatebeginChange}
                />
              </div>
              <div>
                <DateInput
                  inputTitle={meters.dateend}
                  dateInput={dateend}
                  handleDateInputChange={handleDateendChange}
                />
              </div>
              <div>
                <TextInput
                  inputTitle={meters.description}
                  textInput={description}
                  handleTextInputChange={handleDescriptionChange}
                />
              </div>
              <ParametersTitle>{memberorder.generalparameters}</ParametersTitle>
              <div>
                <TextInput
                  inputTitle={compte.energy[energy].meters.key}
                  textInput={clef}
                  handleTextInputChange={handleClefChange}
                />
              </div>
              <div>
                <TextInput
                  isRequired
                  inputTitle={compte.energy[energy].meters.meternumber}
                  textInput={meternumber}
                  handleTextInputChange={handleMeternumberChange}
                />
              </div>
              <div>
                <CustomSelect
                  inputTitle={compte.energy[energy].meters.status}
                  selectValue={status}
                  handleSelectValueChange={handleStatusChange}
                  data={statusData}
                />
              </div>
              <div>
                <TextInput
                  inputTitle={compte.energy[energy].meters.name}
                  textInput={name}
                  handleTextInputChange={handleNameChange}
                />
              </div>
              <div>
                <TextInput
                  inputTitle={compte.energy[energy].meters.serialnumber}
                  textInput={serialnumber}
                  handleTextInputChange={handleSerialnumberChange}
                />
              </div>
              <div>
                <LocalizationAutocomplete
                  specialWidth={"97%"}
                  inputTitle={compte.energy[energy].meters.address}
                  value={address}
                  setValue={setAddress}
                  inputValue={inputValue}
                  setInputValue={setInputValue}
                  options={options}
                  setOptions={setOptions}
                  setValidatedAddress={setValidatedAddress}
                  validatedAddress={validatedAddress}
                  loaded={loaded}
                />
              </div>
              <div>
                <CustomSelect
                  inputTitle={
                    compte.energy[energy].meters.dso
                  }
                  selectValue={metersDso}
                  handleSelectValueChange={handleDsoChange}
                  data={dsoData}
                />
              </div>
              <div>
                <CustomSelect
                  inputTitle={
                    compte.energy[energy].meters.associatedcontractid
                  }
                  selectValue={associatedcontractid}
                  handleSelectValueChange={handleAssociatedcontractidChange}
                  data={utilitiesData}
                />
              </div>
              <ParametersTitle>{memberorder.tractivationparameters}</ParametersTitle>
              <div>
                <CustomSwitch
                  inputTitle={
                    compte.energy[energy].meters.monthlyconsumption
                  }
                  checkedState={monthlyconsumption}
                  handleSwitchChange={handleMonthlyconsumptionChange}
                />
              </div>
              <div>
                <CustomSwitch
                  inputTitle={compte.energy[energy].meters.dailyconsumption}
                  checkedState={dailyconsumption}
                  handleSwitchChange={handleDailyconsumptionChange}
                />
              </div>
              <div>
                <CustomSwitch
                  inputTitle={compte.energy[energy].meters.loadcurve}
                  checkedState={loadcurve}
                  handleSwitchChange={handleLoadcurveChange}
                />
              </div>
              <div>
                <CustomSwitch
                  inputTitle={compte.energy[energy].meters.contractualdata}
                  checkedState={contractualdata}
                  handleSwitchChange={handleContractualdataChange}
                />
              </div>
              <div>
                <CustomSwitch
                  inputTitle={compte.energy[energy].meters.utilitydata}
                  checkedState={utilitydata}
                  handleSwitchChange={handleUtilitydataChange}
                />
              </div>
              <Button
                disabled={buttonDisabled}
                className={
                  buttonDisabled
                    ? classes.submitButtonDisabled
                    : classes.submitButton
                }
                onClick={() => {
                  handleNextPage();
                }}
              >
                {memberorder.pagenext}
              </Button>
            </GridItem>
            : page === 2 ?
              <>
                <GridItem xs={12} sm={6} md={7} lg={7}>
                  <ParametersTitle>{memberorder.attributionparameters}</ParametersTitle>
                  <ParametersNote>{memberorder.noteattribution}</ParametersNote>
                  <div>
                    <CustomSelect
                      inputTitle={site.energy[energy].meters.divisionunit}
                      selectValue={divisionunit}
                      handleSelectValueChange={handleDivisionunitChange}
                      data={divisionUnitData}
                    />
                  </div>
                  <div>
                    <FloatInput
                      inputTitle={site.energy[energy].meters.divisionvalue}
                      floatInput={divisionvalue}
                      handleFloatInputChange={handleDivisionvalueChange}
                    />
                  </div>
                  <div>
                    <CustomSelect
                      inputTitle={metertext.datedistribution}
                      selectValue={datedistribution}
                      handleSelectValueChange={handleDatedistributionChange}
                      data={datedistributionData}
                    />
                  </div>
                  <Button
                    disabled={button2Disabled}
                    className={
                      button2Disabled
                        ? classes.submitButtonDisabled
                        : classes.submitButton
                    }
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    {memberorder.validate}
                  </Button>
                </GridItem>
                <GridItem xs={12} sm={6} md={5} lg={5}>
                  <div className={classes.treeVisible}>
                    <TreeHeader>
                      <TreeLabel>Choix du périmètre</TreeLabel>
                      <Tooltip title="Ajouter un groupe">
                        <SmallButton
                          onClick={handleClickOpenAdd}
                          color={"success"}
                          className={classes2.actionButton}
                          disabled={!groups || groups === '0'}
                        >
                          <AddIcon fontSize="large" />
                        </SmallButton>
                      </Tooltip>
                    </TreeHeader>

                    <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                      <EmbeddedEntitesTree
                        selectedIds={setGroups}
                        userSelectedIds={groups}
                        filterfromnode={groupsParent}
                      />
                    </ImageList>
                  </div>
                </GridItem>
              </>
              : <></>
          }


        </GridContainer>
        <Dialog
          onClose={handleAddClose}
          aria-labelledby="edituser-dialog-title"
          fullWidth="true"
          maxWidth="sm"
          open={openAdd}
        >
          <CustomDialogTitle id="customized-dialog-title" onClose={handleAddClose}>
            Ajouter un groupe
          </CustomDialogTitle>
          <DialogContent dividers>
            <AddGroupDialog
              closeModal={handleAddClose}
              handleSubmitSuccess={handleAddSuccess}
              parentGroup={groups}
            />
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </form>
    </>
  );
}

export default AddMeterToAccountDialog;
